import { render } from "./CartSummaryTable.vue?vue&type=template&id=829a07c8"
import script from "./CartSummaryTable.vue?vue&type=script&lang=js"
export * from "./CartSummaryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__